import type { Subscription } from '../../../types';

function getDowngradeOptions(subscription: Subscription) {
  const subscriptionHours =
    subscription.entitlements.find(({ type }) => type === 'tutoring_hours')?.configuration
      .number_of_hours || 0;

  return (
    subscription.upgrade_downgrade_options?.hour_change_options.filter(
      (option) =>
        (option.entitlements.find(({ type }) => type === 'tutoring_hours')?.configuration
          .number_of_hours || 0) < subscriptionHours
    ) ?? []
  ).concat(
    subscription?.upgrade_downgrade_options?.plan_change_options?.filter(
      ({ contract: { duration_periods } }) => duration_periods !== 1
    ) ?? []
  );
}

export default getDowngradeOptions;
